module.exports = __webpack_public_path__ + "static/media/Commuter-Hub_1080x1920@2x.7c3a0347.png";